import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexContainer } from 'styles/layouts';

// TODO: Change border radius to design system, once "calculations" are possible
export const BannerWrapper = styled(FlexContainer)`
  flex-direction: column-reverse;
  border-radius: 14px;
  border: 2px solid ${themeStyle.varInkLight};

  ${QUERIES.largeTabletAndUp} {
    flex-direction: row;
  }
`;

export const TextWrapper = styled(FlexContainer)`
  padding: 32px 24px;
  background: ${themeStyle.backgroundAlt};
  align-items: center;
  border-radius: 0px 0px ${themeStyle.radiusLarge} ${themeStyle.radiusLarge};

  ${QUERIES.largeTabletAndUp} {
    padding: 48px 20px 48px 48px;
    border-radius: ${themeStyle.radiusLarge} 0px 0px ${themeStyle.radiusLarge};
  }

  html[data-theme='dark'] &&,
  .dark && {
    background: ${themeStyle.varInkSuperLight};
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    width: 200px;
  }
`;

export const BannerImage = styled.img`
  border-radius: ${themeStyle.radiusLarge} ${themeStyle.radiusLarge} 0px 0px;
  height: 328px;
  width: 100%;

  ${QUERIES.largeTabletAndUp} {
    border-radius: 0px ${themeStyle.radiusLarge} ${themeStyle.radiusLarge} 0px;
    height: 518px;
    width: 518px;
  }
`;
